/** Page to go back to, for the layout (the menu entry of the list a detail was opened from). */
import { safeNextPath } from '@/lib/auth-utils';

/**
 * Query parameter with the page to go back to: the list a detail was opened from, filters and
 * search included. Same value and rule as `BACK_PARAM`/`backTarget` of
 * `features/movements/movement-utils.ts`, repeated here so the layout does not depend on a feature.
 */
export const BACK_PARAM = 'torna';

/**
 * The `torna` page of a query string ("?torna=…"), when it is a path of this app by the rule of the
 * login redirect (`safeNextPath`: never "//host", an auth page, a backslash or a control
 * character); null otherwise.
 */
export function backTarget(search: string): string | null {
  const target = new URLSearchParams(search).get(BACK_PARAM);
  return target && safeNextPath(target) === target ? target : null;
}
